<template>
	<div class="main">
		<ul class="nav nav-tabs" role="tablist">
			<li>
				<router-link :to="{name:'stay.revoke'}">銷點申請查詢</router-link>
			</li>
			<li class="active">
				<a data-toggle="tab">申請銷點說明</a>
			</li>
		</ul>
		<section class="panel panel-default">
			<header class="panel-heading">
				<h2 class="panel-title">申請銷點說明</h2>
			</header>
			<div class="panel-collapse collapse in">
				<ckeditor v-model="content" :config="editorConfig"></ckeditor>
			</div>
		</section>
		<div class="col-md-12">
			<div class="s_tenc">
				<a @click="$router.push({ name: 'stay.revoke' })" class="btn-upload btn s_btn_g">返回</a>
				<a @click="saveClick" class="btn-upload btn s_btn_b">儲存</a>
			</div>
		</div>
	</div>
</template>

<script>
/* global bootbox */
import CKEditor from "@/ckeditor4";

export default {
	components: {
		ckeditor: CKEditor.component
	},
	data() {
		return {
			type: "stay-revoke",
			content: "",
			editorConfig: {
				extraPlugins: ["colorbutton"],
				height: 500,
				toolbar: [
					["Source"],
					["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
					["Undo", "Redo"],
					["RemoveFormat"],
					["NumberedList", "BulletedList"],
					["Outdent", "Indent"],
					["Blockquote"],
					["Link", "Unlink", "Anchor"],
					["Table", "HorizontalRule"],
					["SpecialChar"],
					"/",
					["Styles", "Format"],
					["Bold", "Italic", "Strike"],
					["TextColor", "BGColor"],
					["Maximize"],
					["About"]
				]
			}
		}
	},
	mounted() {
		if (!this.sessionData || !this.isAdmin('stay')) {
			this.$router.replace({ name: 'stay.revoke' });
			return;
		}
		this.$axios.get(`/api/common/treaty?type=${this.type}`).then(resp => {
			this.content = this.htmlDecode(resp.data.content || "");
		}).catch(() => {
			this.content = "";
		});
	},
	methods: {
		saveClick() {
			if (!this.content) {
				bootbox.alert("請填寫內容");
				return;
			}

			const formData = new FormData();
			formData.append("treaty", JSON.stringify({
				content: this.htmlEncode(this.content)
			}));
			formData.append("type", this.type);
			this.$axios.post(`/api/common/saveTreaty`, formData).then(resp => {
				bootbox.alert(resp.data.msg, () => {
					if (resp.data.status === "success") {
						this.$router.push({ name: 'stay.revoke' });
					}
				});
			});
		}
	}
}
</script>